import { useParams } from "react-router-dom";
import { recordGetRequest } from "../api/getRecords";
import { useEffect, useState } from "react";
import { formatDateForQRCheck } from "shared/lib/hooks/useDateFormatting";
import { Button } from "shared/ui/button";
import daw from "shared/assets/images/Daw.svg";
import cross from "shared/assets/images/Cross.svg";
import styles from "./RecordCheckQR.module.scss";

export const RecordCheckQR = () => {
  const { recordId } = useParams();

  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getRecord = async (id) => {
    try {
      setLoading(true);
      setError(null);

      const data = await recordGetRequest(id);
      setRecord(data);
    } catch (e) {
      setError(e.message || "Ошибка загрузки");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!recordId) return;
    getRecord(recordId);
  }, [recordId]);

  if (loading) return <div>Загрузка...</div>;
  if (error) return <div>Ошибка: {error}</div>;
  if (!record || typeof record !== "object") return <div>Нет данных</div>;

  return (
    <div className={styles.contentWrapper}>
      <div className={styles.imgBlock}>
        <img
          src={`data:image/png;base64,${record?.image}`}
          alt={record?.headers || "event_image"}
          className={styles.imgBlock__img}
        />
      </div>
      <div className={styles.textBlock}>
        <p className={styles.textBlock__title}>{record?.eventName}</p>
        <p className={styles.textBlock__subTitle}>
          {formatDateForQRCheck(record?.plannedDate)}
        </p>

        <p className={styles.textBlock__text}>
          ФИО участника:{" "}
          <span className={styles.textBlock__textBold}>{record?.userFio}</span>
        </p>
        <div className={styles.textBlock__button}>
          {record?.payment ? (
            <Button
              size="large"
              disabled={true}
              variant="primary"
              rightIcon={<img src={daw} alt="daw" width={20} height={20} />}
            >
              Оплачено
            </Button>
          ) : (
            <Button
              size="large"
              disabled={true}
              variant="danger"
              rightIcon={<img src={cross} alt="cross" width={20} height={20} />}
            >
              Не оплачено
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
